document.addEventListener("alpine:init", () => {
  Alpine.data("recentlyViewed", function (data) {
    return {
      products: this.$persist([]),
      scrollPos: 0,
      hasReachedEnd: false,
      needsScroll: false,
      filteredProducts() {
        return this.products.filter((el) => el.id !== data.id);
      },
      init() {
        if (data.id) {
          this.findAndAdd(data);
        }
      },
      findAndAdd(data) {
        if (data) {
          const index = this.products.findIndex((el) => el.id === data.id);
          if (index === -1) {
            this.products.unshift(data);
          } else {
            this.products.splice(index, 1);
            this.products.unshift(data);
          }
          if (this.products.length > 20) {
            this.products = this.products.slice(0, 19);
          }
        }
      },
      scrollNext() {
        this.$refs.scrollcontainer.scrollTo({
          top: 0,
          left: this.$refs.scrollcontainer.scrollLeft + 100,
          behavior: "smooth",
        });
        this.scrollPos = this.$refs.scrollcontainer.scrollLeft;
      },
      scrollPrev() {
        this.$refs.scrollcontainer.scrollTo({
          top: 0,
          left: this.$refs.scrollcontainer.scrollLeft - 100,
          behavior: "smooth",
        });
        this.scrollPos = this.$refs.scrollcontainer.scrollLeft;
      },
      scrollDetecter() {
        const div = this.$refs.scrollcontainer;
        if (div) {
          this.scrollPos = div.scrollLeft;
          if (div.scrollWidth > div.offsetWidth) {
            this.needsScroll = true;
          }
          if (div.scrollLeft + div.offsetWidth >= div.scrollWidth) {
            this.hasReachedEnd = true;
          } else {
            this.hasReachedEnd = false;
          }
        }
      },
    };
  });
});
